const locales = {
  frc: 'fr-CA',
  dan: 'da',
  esp: 'es',
  fin: 'fi',
  rus: 'ru',
  chs: 'zh-Hans',
  hrv: 'hr',
  fra: 'fr',
  nld: 'nl',
  jpn: 'ja',
  cat: 'ca',
  hun: 'hu',
  ita: 'it',
  plk: 'pl',
  csy: 'cs',
  ptb: 'pt-BR',
  eng: 'en-GB',
  deu: 'de',
  rom: 'ro',
  cht: 'zh-Hant',
  kor: 'ko',
  trk: 'tr',
  ptg: 'pt-PT',
  enu: 'en',
  sve: 'sv',
  nor: 'no',
  non: 'nn',
  nob: 'nb',
  zhh: 'zh-Hant-HK',
  esc: 'es-CL',
  eso: 'es-CO',
  esm: 'es-MX',
  frs: 'fr-CH',
  frb: 'fr-BE',
  frl: 'fr-LU',
  its: 'it-CH',
  des: 'de-CH',
  deb: 'de-BE',
  del: 'de-LU',
  nlb: 'nl-BE',
  ptl: 'pt-LU',
  ens: 'en-US',
  enc: 'en-CA'
};
export const mappedLocales = {
  [locales.ptg]: locales.ptb,
  [locales.ptl]: locales.ptb,
  [locales.esc]: locales.esp,
  [locales.eso]: locales.esp,
  [locales.esm]: locales.esp,
  [locales.frs]: locales.fra,
  [locales.frb]: locales.fra,
  [locales.frl]: locales.fra,
  [locales.its]: locales.ita,
  [locales.des]: locales.deu,
  [locales.deb]: locales.deu,
  [locales.del]: locales.deu,
  [locales.nlb]: locales.nld,
  [locales.non]: locales.nor,
  [locales.nob]: locales.nor,
  [locales.ens]: locales.enu,
  [locales.enc]: locales.enu
};
export const supportedLocales = [locales.enu, locales.deu, locales.fra, locales.eng, locales.esp, locales.ptb, locales.jpn, locales.chs, locales.zhh, locales.nld, locales.sve, locales.dan, locales.frc, locales.ita, locales.kor, locales.rus, locales.plk, locales.csy, locales.cht, locales.nor];
export const defaultLocale = locales.enu;
//# sourceMappingURL=consts.js.map